import styled from 'styled-components';
import { Error } from '@mui/icons-material';

export const StyledErrorBox = styled.div`
  ${({ theme }) => `
    margin-top: ${theme.uptimeSpace[10]}px;
    .error_image {
      width: 100%;
      max-width: 300px;
    }
    .title {
      font-weight: bold;
      color: navy;
      text-transform: uppercase;
    }
  `}
`;

export const ErrorIcon = styled(Error)`
  ${({ theme }) => `
    color: ${theme.colors.state.danger};
    width: 100px !important;
    font-size: 100px !important;
  `}
`;